import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import './menudois.css'
// import IconWhite from '../../assets/Utils/Logo_Menor.png'


export default class MenuDefault extends Component {
  constructor() {
    super()

    this.state = {
      headerStatus: 'home',
      openedMenu: 'off',
      renderBlog: false,
      renderSchedule: false
    }
  }

  onClickChangeColor() {
    let status = ''
    if (window.location === '/') {
      status = 'home'
    }
    this.setState({
      headerStatus: status,
      openedMenu: 'off'
    })
  }

  contentRender() {
    return (
      <ul onClick={() => this.onClickChangeColor()}>
        {/* <li>
          <NavLink to="/" exact title="Quem?" activeClassName="active">
            Home
          </NavLink>
        </li> */}
        <li>
          <NavLink to="/aboutUs" title="Sobre Nós" activeClassName="active">
            Sobre
          </NavLink>
        </li>
        <li>
          <NavLink to="/workshop" title="cursos" activeClassName="active">
            Cursos
          </NavLink>
        </li>
        {this.state.renderSchedule ? (
          <li>
            <NavLink to="/schedule" title="schedule" activeClassName="active">
              Calendário
            </NavLink>
          </li>
        ) : null
        }
        {this.state.renderBlog ? (
          <li>
            <NavLink to="/blog" title="blog" activeClassName="active">
              Blog
            </NavLink>
          </li>
        ) : null
        }
        <li>
          <NavLink to="/contact" title="Contato" activeClassName="active">
            Contato
          </NavLink>
        </li>
        {/* <li >
          <NavLink to="/workshop" title="Cursos de Verão" activeClassName="active">
            <img src={IconWhite} alt="Cursos de Verão" />
            <span style={{ alignItems: "center", verticalAlign: "top", paddingLeft: "5px" }}>
              Ofertas
            </span>
          </NavLink>
        </li> */}
        <li>
          <NavLink to="/workshop" title="Curso de Férias" activeClassName="active">
            Ofertas
          </NavLink>
        </li>
        {/* <li >
          <NavLink to="/live" title="live" activeClassName="active" >
            <span style={{color:"#fbd218"}}>Live</span>
          </NavLink>
        </li> */}

      </ul>
    )
  }

  openMenuMobile() {
    if (this.state.openedMenu !== 'active') {
      return this.setState({
        openedMenu: 'active'
      })
    }
    this.setState({
      openedMenu: 'off'
    })
  }

  render(element) {
    const colorHead = `App-header ${this.state.headerStatus}`
    return (
      <header className={colorHead}>
        <nav id="DefaultNav">
          <div className="squad">
            <h1>
              <a href='/'>
                <div className="divLogo">
                <img src='/imgs/logohit.png' alt='Logo Hit-Bra' />
                </div>
                {/* <span><span>We always lead with hits. If you want to have success, you have to be riding a hit.</span></span> */}
              </a>
            </h1>
            <div className="justDesktop">
              {this.contentRender()}
            </div>
            <div className="justMobile">
              <div className="menuMobile" onClick={() => this.openMenuMobile()}>
                <i className="fa fa-bars"></i>
              </div>
              <div className={this.state.openedMenu}>
                {this.contentRender()}
              </div>
            </div>
          </div>
        </nav>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/menu.js